/**
 * Normaliza um objeto transformando campos null e undefined em strings vazias
 * @param {Record<string,unknown>} inputObject - O objeto a ser normalizado
 * @returns {Record<string,unknown>} - O objeto normalizado com campos null/undefined convertidos para strings vazias
 * @example
 * const objeto = {
 *   teste: "abc",
 *   novo: null,
 *   certo: undefined
 * };
 *
 * const resultado = normalizeObject(objeto);
 * // resultado: { teste: "abc", novo: "", certo: "" }
 */
export const normalizeObject = (
  inputObject: Record<string, unknown>
): Record<string, unknown> => {
  if (!inputObject || typeof inputObject !== "object") {
    return inputObject;
  }

  const normalizedObject: Record<string, unknown> = {};

  for (const [key, value] of Object.entries(inputObject)) {
    if (value === null || value === undefined) {
      normalizedObject[key] = "";
    } else if (typeof value === "object" && !Array.isArray(value)) {
      normalizedObject[key] = normalizeObject(value as Record<string, unknown>);
    } else {
      normalizedObject[key] = value;
    }
  }

  return normalizedObject;
};

export default normalizeObject;
